import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../../axiosBaseQuery";


const UsageApi = createApi({
    reducerPath: "core/usage",
    baseQuery: axiosBaseQuery,
    tagTypes: ["usageList"],
    endpoints: (builder) =>({
        usageFindAll: builder.query<{ data: any[]; pagination: any }, string | void>({
            providesTags: ['usageList'],
            query: (query = '') => ({
                url: "core/usage/" + query,
                method: "GET",
            }),
            transformResponse: (response: any) => {
                return {
                    data: response.data,
                    pagination: response?.pagination,
                };
            },
        }),
        usageCreate: builder.mutation({
            invalidatesTags: ['usageList'],
            query: (data)=>({url: "core/usage/", method: "POST", data})
        }),
        usageUpdate: builder.mutation({
            invalidatesTags: ['usageList'],
            query: (data)=>({url: "/core/usage/"+data.id, method: "PUT", data})
        }),
        // console.log(data);
        
        usageDelete: builder.mutation({
            invalidatesTags: ['usageList'],
            query: (id)=>({url: "/core/usage/"+id, method: "DELETE"})
        }),
    })
})

export const { useUsageFindAllQuery, useUsageCreateMutation, useUsageUpdateMutation, useUsageDeleteMutation } = UsageApi;
export {UsageApi};
